module.exports = __webpack_public_path__ + "img/paper_upload.a27f1347.svg";